import React from 'react';

import ActionCard from '../../components/ActionCard';
import Button from '../../components/Button';

function ExampleFormCard({category, file, form}) {
  return (
    <ActionCard
      title={form.name}
      description={form.description}
      action={<Button to={`/forms/create/${category.path}/${file.replace('.json', '')}`}>Use Template</Button>}
    />
  );
}

export default ExampleFormCard;